import options from './chart-proximity.component';

export default {
    selector: 'dtChartProximity',
    options
};
